<template>
  <div class="flex-col h-100">
    <div style="height: 100%">
      <div class="flex-row title">
        <span class="iconfont iconarrowleft-outline left-icon"
          @click="goBack"></span>
      </div>
      <div class="head">
        <div class="head-info"
          style="">
          <van-image class="head-image"
            fit="fill"
            :src="userInfo.photoBase64" />
          <!-- <button class="edit" @click="editRelationship">编辑</button> -->
          <span v-if="!isMarked && isCollectPage"
            class="mark not-marked"
            @click="mark">
            + {{ $t("collection") }}
          </span>
          <span v-if="isMarked && isCollectPage"
            class="mark marked"
            @click="mark">
            {{ $t("collected") }}
          </span>
        </div>
      </div>
      <div class="flex-col user-info">
        <div class="flex-row">
          <span class="name-info">{{ userInfo.englishName }}</span>&nbsp;&nbsp;&nbsp;<span class="title-info">{{
                        userInfo.jobTitle
                    }}</span>
        </div>
        <span class="los-info">{{ userInfo.los }}/{{ userInfo.city }}</span>
        <span class="email-info">{{ userInfo.email }}</span>
        <div class="flex-row deep-line">
          <div style="flex: none">
            <span>{{ $t("RelationDeepth") }}：</span><span style="color: #d04a02">{{
                            item.relationDeepth
                        }}</span>
          </div>
          <!-- <div class="border-info"></div> -->
        </div>
        <div class="flex-row detail-info">
          <div class="flex-row">
            <van-image class="contact-image"
              fit="fill"
              :src="item.logo" />
            <div class="flex-col">
              <label class="contact-info">{{
                                item.peContactName
                            }}</label>
              <div class="flex-row deep-info">
                <span>{{ item.peOrganizationName }}</span><span v-if="item.responsibility!=null">&nbsp;·&nbsp;</span><span>{{
                                    item.responsibility
                                }}</span><span v-if="item.position!=null">&nbsp;·&nbsp;</span><span>{{ item.position }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="divide-info"
        v-if="isCollectPage"></div>
      <div class="flex-col search-line"
        v-if="isCollectPage">
        <span class="search-info">搜索线</span>
        <van-steps direction="vertical"
          :active="2"
          active-color="#D04a02">
          <van-step class="step-info">
            <h4 style="color: black">投资阶段</h4>
            <div class="item-tags">
              <van-tag v-if="investPreference!=null && investPreference.length>0"
                color="#F7F7F7"
                text-color="#464646"
                size="large ">
                {{ investPreference }}</van-tag>
            </div>
          </van-step>
          <van-step class="step-info">
            <h4 style="color: black">投资类型</h4>
            <div class="item-tags">
              <van-tag v-for="name in lisIndustries"
                :key="name"
                color="#F7F7F7"
                text-color="#464646"
                size="large ">
                {{ name }}</van-tag>
            </div>
          </van-step>
          <van-step class="step-info">
            <h4 style="color: black">行业</h4>
            <div class="item-tags">
              <van-tag v-for="name in lisInvestTypes"
                :key="name"
                color="#F7F7F7"
                text-color="#464646"
                size="large ">
                {{ name }}</van-tag>
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
    <div class="edit-style"
      v-if="!isCollectPage">
      <div class="know-him-button-button"
        @click="editRelationship()">
        {{ $t("common.edit") }}
      </div>
    </div>
  </div>
</template>

<script>
import webService from "../../network/webService";
import _ from "lodash";
import common from "../../common/common";
import commonStyle from "../../styles/common.scss";
import { Toast } from "vant";
export default {
  name: "RelationshipDetail",
  components: {
    Toast,
  },
  data () {
    return {
      isMarked: false,
      buttonDisabled: false,
      item: {},
      userInfo: {},
      isCollectPage: false,
      lisIndustries: [],
      lisInvestTypes: [],
      investPreference: "",
    };
  },
  created () {
    this.isCollectPage = this.$route.query.isCollect == 1;
    if (this.$route.query.id) {
      var param = [this.$route.query.id];
      webService.getRelationshipsByIds(param).then((res) => {
        if (res.data.length == 0) return;

        this.item = res.data[0];
        console.log(this.item);
        this.userInfo = this.item.userProfile;
        this.isMarked = this.item.marked;

        webService
          .getFavoriteDetail(this.item.peOrganizationId)
          .then((res) => {
            if (res.data && res.data.sucess) {
              let data = res.data.data;
              this.lisIndustries = data.lisIndustries;
              this.lisInvestTypes = data.lisInvestTypes;
              this.investPreference = data.investPreference;
            } else {
            }
          });
      });
    }
    common.addViewHistory(
      this.$route.query.id,
      common.favoriteTypeEnum.Relationship
    );
  },
  methods: {
    goBack () {
      this.$router.go(-1);
    },
    getContactRelationshipCount (contactId) {
      webService.getContactRelationshipCount(contactId).then((res) => {
        this.contactCount = res.data;
      });
    },
    editRelationship () {
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          relationshipId: this.item.id
        },
      });
    },
    mark () {
      common.mark(
        this,
        this.item.id,
        common.favoriteTypeEnum.Relationship,
        this.isMarked
      );
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../styles/theme.scss";
.title {
  background-color: #d04a02;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.left-icon {
  font-size: 30px;
  padding-left: 1rem;
  color: white;
}
.head {
  //   position: relative;
  padding: 0 1rem;
}
.head-info {
  height: 2.875rem;
  position: relative;
}
.head-image {
  position: absolute;
  top: -1.375rem;
  height: 5rem;
  width: 5rem;
}
.edit {
  position: absolute;
  width: 60px;
  height: 30px;
  right: 0;
  bottom: 0px;
  margin-right: 120px;
  color: white;
  background-color: #eb8c00;
  border: none;
}
.head-button {
  margin-top: 1rem;
  background-color: #f1733c;
  margin-top: 1rem;
  border: 1px solid #f1733c;
  height: 30px;
}
.detail-info {
  padding: 1rem 1rem 0 0;
  justify-content: space-between;
}
.user-info {
  padding: 1.625rem 1rem 1rem 1rem;
  overflow: auto; // flex: 1;
}
.name-info {
  font-size: 26px;
  color: #464646;
}
.title-info {
  font-size: 11px;
  color: $color-pwctheme;
  padding-top: 15px;
}
.border-info {
  border-bottom: 1px dashed #979797;
  width: 100%;
  float: left;
  height: 10px;
  /* padding-left: 7px; */
  margin-left: 5px;
}
.los-info {
  padding-top: 0.5rem;
  font-size: 12px;
  color: #7d7d7d;
}
.email-info {
  padding-top: 0.5rem;
  font-size: 16px;
  color: #7d7d7d;
}
.contact-info {
  font-size: 14px;
  font-weight: bold;
  color: #2d2d2d;
  padding: 0.5rem;
}
.contact-image {
  padding: 0.5rem 0.5rem 0.5rem 0;
  width: 44px;
  height: 44px;
}
.deep-line {
  padding-top: 0.5rem;
  font-size: 14px;
  color: #464646; //font-weight: 600;
}
.deep-info {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 13px;
  color: #7d7d7d;
}
.org-info {
  padding: 0.5rem 0.5rem 1rem 0.5rem;
  font-size: 14px;
  color: #2d2d2d;
}
.detail-icon {
  font-size: 1.5rem;
  margin-top: 2rem;
  color: lightslategray;
}
.divide-info {
  height: 1px;
  background-color: #ececec;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}
.step-info {
  padding: 1px 10px 10px 0;
}
.search-line {
  margin-top: 8px;
  padding: 1rem;
  .search-info {
    padding-top: 0.5rem;
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
  }
}
.edit-style {
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.know-him-button-button {
  width: 60%;
  border: 1px solid orangered;
  text-align: center;
  padding: 10px 20px;
  color: orangered;
}
</style>


// WEBPACK FOOTER //
// src/views/profile/RelationshipDetail.vue